import './brandtv-backdrop.scss';
import { getEnv } from '@/utils/env';

const BrandTVBackdrop = () => {
  const { VITE_ASSET_SERVER } = getEnv();
  const image = `${VITE_ASSET_SERVER}/bl-platform/images/brandtv-moon.webp`;
  return <img className="brandtv-backdrop" src={image} alt="brandtv backdrop" />;
};

export default BrandTVBackdrop;
